import { Link } from "react-router-dom";
import VendorlyLogo from "@/components/VendorlyLogo";
import { ArrowLeft } from "@phosphor-icons/react";

export default function LegalLayout({ title, updated, children }) {
  return (
    <div className="min-h-screen bg-brand-bg text-brand-text">
      <header className="sticky top-0 z-40 backdrop-blur-md bg-brand-bg/70 border-b border-brand-border">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <VendorlyLogo size={28} />
            <span className="font-heading font-bold text-lg tracking-tight">Vendorly</span>
          </Link>
          <Link to="/" className="text-sm font-medium hover:text-brand-primary inline-flex items-center gap-1.5">
            <ArrowLeft size={14} weight="bold" /> Back to home
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 lg:px-10 py-14">
        <div className="text-xs uppercase tracking-[0.2em] text-brand-secondary mb-3">Legal</div>
        <h1 className="font-heading font-bold text-4xl sm:text-5xl tracking-tight mb-2" data-testid="legal-title">{title}</h1>
        {updated && <p className="text-brand-textMuted text-sm mb-10">Last updated: {updated}</p>}
        <article className="prose prose-neutral max-w-none text-brand-text/85 leading-relaxed space-y-5">
          {children}
        </article>
      </main>
      <footer className="border-t border-brand-border py-8 mt-10">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 text-xs text-brand-textMuted flex flex-wrap gap-x-6 gap-y-2">
          <Link to="/about" className="hover:text-brand-primary">About</Link>
          <Link to="/contact" className="hover:text-brand-primary">Contact</Link>
          <Link to="/privacy" className="hover:text-brand-primary">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-brand-primary">Terms &amp; Conditions</Link>
          <Link to="/refunds" className="hover:text-brand-primary">Refund Policy</Link>
          <span className="ml-auto">© {new Date().getFullYear()} Vendorly</span>
        </div>
      </footer>
    </div>
  );
}

export function P({ children }) { return <p>{children}</p>; }
export function H2({ children }) { return <h2 className="font-heading font-bold text-2xl mt-10 mb-3 text-brand-text">{children}</h2>; }
export function UL({ children }) { return <ul className="list-disc pl-6 space-y-1.5">{children}</ul>; }
